import * as constActions from './Const';
import initialState from './initialState';

export default function searchEntityReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.GET_RESULTS_SUCCESS: {
      return Object.assign({}, state, {
        results: action.results //uniqueKeyResults
      });
    }
    case constActions.SEARCH_RESULTS_SUCCESS: {
      return Object.assign({}, state, {
        results: action.results //uniqueKeyResults
      });
    }
    case constActions.SEARCH_ENTITY_RESULTS_LOAD_MORE_SUCCESS: {
      return Object.assign({}, state, {
        results: [...state.results, ...action.results] //uniqueKeyResults
      });
    }
    case constActions.GET_ALL_COULMNS_SEARCH_SUCCESS: {
      return Object.assign({}, state, {
        allColumns: action.searchColumns
      });
    }
    case constActions.INIT_SEARCH_DISPLAY_FIELDS: {
      return Object.assign({}, state, {
        displayFields: action.displayFields
      });
    }
    case constActions.ADD_SEARCH_HEADER_DISPLAY: {
      return Object.assign({}, state, {
        displayFields: [...state.displayFields, ...action.columns]
      });
    }
    case constActions.REMOVE_SEARCH_HEADER_DISPLAY: {
      return Object.assign({}, state, {
        displayFields: [...state.displayFields.slice(0, action.index), ...state.displayFields.slice(action.index + 1)]
      });
    }
    case constActions.SET_SEARCH_HEADER_DISPLAY: {
      return Object.assign({}, state, {
        displayFields: action.columns
      });
    }
    case constActions.INIT_SEARCH_CRITERIEAS: {
      let arr = action.criterieas.map(function (item, index) {
        return Object.assign({}, item, {
          key: index
        });
      });
      return Object.assign({}, state, {
        criterieas: arr
      });
    }
    case constActions.ADD_SEARCH_CRITERIEA: {
      return Object.assign({}, state, {
        criterieas: [...state.criterieas, ...action.criterieas]
      });
    }
    case constActions.REMOVE_SEARCH_CRITERIEA: {
      return Object.assign({}, state, {
        criterieas: [...state.criterieas.slice(0, action.index), ...state.criterieas.slice(action.index + 1)]
      });
    }
    case constActions.UPDATE_SEARCH_CRITERIEA: {
      return Object.assign({}, state, {
        criterieas: state.criterieas
          ? state.criterieas.map(item => {
              if (item.key == action.obj.key) return action.obj;
              return item;
            })
          : [action.obj]
      });
    }
    case constActions.SET_SITES_BY_USER_LOGGED_IN:
      return Object.assign({}, state, {
        sitesByLoggedInUser: action.data
      });
    default:
      return state;
  }
}
